import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './contactDetails.scss';
import { useTranslation } from 'react-i18next';

export default function ContactDetailsFilter({ value, onChange, onClear, empty, notificationFilter }) {
  const { t: tr } = useTranslation();
  const [show, setShow] = useState(false);
  const dialog = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    if (!show) return undefined;
    if (dialog.current.showModal) dialog.current.showModal();
    else dialog.current.setAttribute('open', '');
    return () => { if (trigger.current) trigger.current.focus(); };
  }, [show]);
  const [draft, setDraft] = useState({ mobile: false, email: false });
  const mobile = value === 'missingMobile' || value === 'missingBoth';
  const email = value === 'missingEmail' || value === 'missingBoth';
  const notificationsActive = notificationFilter != null && notificationFilter !== 'all';
  const count = Number(mobile) + Number(email) + Number(notificationsActive);
  const open = () => { setDraft({ mobile, email, notificationFilter }); setShow(true); };
  const apply = () => {
    let contactValue = 'all';
    if (draft.mobile && draft.email) contactValue = 'missingBoth';
    else if (draft.mobile) contactValue = 'missingMobile';
    else if (draft.email) contactValue = 'missingEmail';
    if (notificationFilter != null) onChange(contactValue, draft.notificationFilter);
    else onChange(contactValue);
    setShow(false);
  };
  return (
    <>
      <button ref={trigger} type="button" className="btn manage-button manage-teal-button contact-filter-button" onClick={open} aria-haspopup="dialog">
        <i className="fas fa-filter mr-2" aria-hidden="true" />{tr("manage:filters_158")}{count ? ` (${count})` : ''}
      </button>
      {(count > 0 || empty) && (
        <div className="contact-active-filters">
          {mobile && <button type="button" className="contact-filter-chip" aria-label={tr("manage:removeFilterMissingPhone_159")} onClick={() => onChange(email ? 'missingEmail' : 'all')}>{tr("manage:missingPhone_160")} <span aria-hidden="true">×</span></button>}
          {email && <button type="button" className="contact-filter-chip" aria-label={tr("manage:removeFilterMissingEmail_161")} onClick={() => onChange(mobile ? 'missingMobile' : 'all')}>{tr("manage:missingEmail_162")} <span aria-hidden="true">×</span></button>}
          {notificationsActive && (
            <button type="button" className="contact-filter-chip" aria-label={tr('manage:notificationFilter.remove')} onClick={() => onChange(value, 'all')}>
              {tr(`manage:notificationFilter.${notificationFilter}Chip`)} <span aria-hidden="true">×</span>
            </button>
          )}
          <button type="button" className="btn btn-link contact-filter-clear" onClick={onClear}>{tr("manage:clearFilters_163")}</button>
          {empty && <div className="w-100" role="status">{tr("manage:noPeopleMatchTheSelectedFilters_164")}</div>}
        </div>
      )}
      {show && <dialog ref={dialog} className="contact-filter-dialog" onCancel={() => setShow(false)} aria-labelledby="contact-filters-title">
        <div className="modal-header"><h4 id="contact-filters-title" className="modal-title">{tr("manage:filters_158")}</h4><button type="button" className="close" aria-label={tr("manage:closeFilters_165")} onClick={() => setShow(false)}><span aria-hidden="true">×</span></button></div>
        <div className="modal-body">
          <label className="contact-filter-choice"><input type="checkbox" checked={draft.mobile} onChange={event => setDraft({ ...draft, mobile: event.target.checked })} />{tr("manage:missingPhone_160")}</label>
          <label className="contact-filter-choice"><input type="checkbox" checked={draft.email} onChange={event => setDraft({ ...draft, email: event.target.checked })} />{tr("manage:missingEmail_162")}</label>
          <p className="text-muted mb-0">{tr("manage:bothSelectedPeopleWithoutAPhoneNumberAndWithout_166")}</p>
          {notificationFilter != null && (
            <div className="form-group mt-3 mb-0">
              <label htmlFor="client-notification-filter">{tr('manage:notificationFilter.label')}</label>
              <select
                id="client-notification-filter"
                className="form-control"
                value={draft.notificationFilter}
                onChange={event => setDraft({ ...draft, notificationFilter: event.target.value })}
              >
                <option value="all">{tr('manage:notificationFilter.all')}</option>
                <option value="enabled">{tr('manage:notificationFilter.enabled')}</option>
                <option value="disabled">{tr('manage:notificationFilter.disabled')}</option>
              </select>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn manage-button manage-teal-button" onClick={() => setShow(false)}>{tr("common:cancel")}</button>
          <button type="button" className="btn manage-button manage-red-button" onClick={apply}>{tr("common:apply")}</button>
        </div>
      </dialog>}
    </>
  );
}

ContactDetailsFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  empty: PropTypes.bool.isRequired,
  notificationFilter: PropTypes.oneOf(['all', 'enabled', 'disabled']),
};

ContactDetailsFilter.defaultProps = { notificationFilter: null };
